import axios from "axios";

//  Base URL 
let baseURL = process.env.VUE_APP_API_BASE_URL;

//   Si la variable .env n'existe pas
if (!baseURL) {
  const hostname = window.location.hostname;

  // Réseau local
  if (
    hostname.startsWith("192.168.") ||
    hostname.startsWith("10.") ||
    hostname === "localhost"
  ) {
    baseURL = "http://127.0.0.1:8000";
  } 
  // PRODUCTION
  else {
    baseURL = "https://api-clinique.mata-groupe.com";
  }
}

//  Instance Axios propre
const apiClient = axios.create({
  baseURL: `${baseURL}/api/v1`,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json"
  }
});

//  Intercepteur JWT
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default {
  // Pagination + filtres
  getItems(resource, { orderBy, itemsperpage, sortOrder, page, search } = {}) {
    const params = { orderBy, sortOrder, itemsperpage, page, search };
    return apiClient.get(`/${resource}`, { params });
  },

  createItem(resource, data, isMultipart = false) {
    return apiClient.post(`/${resource}`, data, {
      headers: isMultipart
        ? { "Content-Type": "multipart/form-data" }
        : { "Content-Type": "application/json" }
    });
  },

  updatePassword(data) {
    return apiClient.put(`/users/update_password`, data);
  },

  updateItem(resource, id, data, isMultipart = false) {
    const url = id ? `/${resource}/${id}` : `/${resource}`;

    if (isMultipart) {
      return apiClient.post(url, data, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    }

    return apiClient.put(url, data);
  },

  deleteItem(resource, id) {
    return apiClient.delete(`/${resource}/${id}`);
  },
  custom(url, method = "PATCH", data = null) {
  return apiClient({
    url: `/${url}`,
    method,
    data
  });
},

  /*patchItem(resource, id, data) {
    return apiClient.put(`/${resource}/${id}`, data);
  },*/
  patchItem(resource, id, data) {
  return apiClient.patch(`/${resource}/${id}`, data);
},

  getItem(resource, id) {
    return apiClient.get(`/${resource}/${id}`);
  },

  post(resource, data) {
    return apiClient.post(`/${resource}`, data);
  }
};
